"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeatureTogglesProvider = exports.useFeatureToggles = exports.elapsedTime = exports.getSessionItem = exports.getFeaturesList = exports.getFeaturesListDummy = exports.Session = exports.APIUrl = exports.ApplicationName = void 0; // NOTE ApplicationName is imported from common

var FeatureToggles_models_1 = require("./FeatureToggles.models");

Object.defineProperty(exports, "ApplicationName", {
  enumerable: true,
  get: function get() {
    return FeatureToggles_models_1.ApplicationName;
  }
});
Object.defineProperty(exports, "APIUrl", {
  enumerable: true,
  get: function get() {
    return FeatureToggles_models_1.APIUrl;
  }
});
Object.defineProperty(exports, "Session", {
  enumerable: true,
  get: function get() {
    return FeatureToggles_models_1.Session;
  }
});

var FeatureToggles_functions_1 = require("./FeatureToggles.functions");

Object.defineProperty(exports, "getFeaturesListDummy", {
  enumerable: true,
  get: function get() {
    return FeatureToggles_functions_1.getFeaturesListDummy;
  }
});
Object.defineProperty(exports, "getFeaturesList", {
  enumerable: true,
  get: function get() {
    return FeatureToggles_functions_1.getFeaturesList;
  }
});
Object.defineProperty(exports, "getSessionItem", {
  enumerable: true,
  get: function get() {
    return FeatureToggles_functions_1.getSessionItem;
  }
});
Object.defineProperty(exports, "elapsedTime", {
  enumerable: true,
  get: function get() {
    return FeatureToggles_functions_1.elapsedTime;
  }
});

var FeatureToggles_1 = require("./FeatureToggles");

Object.defineProperty(exports, "useFeatureToggles", {
  enumerable: true,
  get: function get() {
    return FeatureToggles_1.useFeatureToggles;
  }
});
Object.defineProperty(exports, "FeatureTogglesProvider", {
  enumerable: true,
  get: function get() {
    return FeatureToggles_1.FeatureTogglesProvider;
  }
});